var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{attrs:{"title":"Targetes virtuals pendents de cobrar"}},[_c('client-payments-table',{attrs:{"payments":_vm.payments,"loading":_vm.loadingPayments,"show-search":"","show-date":"","show-client":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }